import React from 'react';
import {AccentedSvgIcon, AccentedSvgIconProps} from './AccentedSvgIcon';

export const MenuIcon = (props: AccentedSvgIconProps): JSX.Element => (
    <AccentedSvgIcon {...props} viewBox="0 0 20 20" className="ue-icon-menu">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.75 2.75C4.75 2.33579 4.41421 2 4 2C3.58579 2 3.25 2.33579
            3.25 2.75V10H3C2.44772 10 2 10.4477 2 11C2 11.5523 2.44772 12
            3 12H3.25V17.25C3.25 17.6642 3.58579 18 4 18C4.41421 18 4.75 17.6642
            4.75 17.25V12H5C5.55228 12 6 11.5523 6 11C6 10.4477 5.55228 10 5
            10H4.75V2.75ZM10.75 2.75C10.75 2.33579 10.4142 2 10 2C9.58579 2
            9.25 2.33579 9.25 2.75V5H9C8.44772 5 8 5.44772 8 6C8 6.55228 8.44772 7 9
            7H9.25V17.25C9.25 17.6642 9.58579 18 10 18C10.4142 18 10.75 17.6642 10.75
            17.25V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H10.75V2.75ZM16 2C16.4142 2
            16.75 2.33579 16.75 2.75V13H17C17.5523 13 18 13.4477 18 14C18 14.5523 17.5523 15 17
            15H16.75V17.25C16.75 17.6642 16.4142 18 16 18C15.5858 18 15.25 17.6642 15.25 17.25V15H15C14.4477 15 14
            14.5523 14 14C14 13.4477 14.4477 13 15 13H15.25V2.75C15.25 2.33579 15.5858 2 16 2Z"
            fill="black"
        />
    </AccentedSvgIcon>
);
